const config = {
    apiUrl: import.meta.env.VITE_BACKEND_URL || 'http://192.168.0.106:5000'
  };
  
  export default config;